/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;
export enum UiMediaRetrievalFailureReason {
	MIC_MEDIA_RETRIEVAL_FAILED, CAM_MEDIA_RETRIEVAL_FAILED, DISPLAY_MEDIA_RETRIEVAL_FAILED, VIDEO_MIXING_FAILED
}